import(/* webpackMode: "eager" */ "D:\\OneDrive\\TS\\ticsoft-bpms-frontend-sakai-react-10.0.0\\app\\layout.tsx")